// MDX does not like to import from 'shared'
import TweetEmbed from 'shared/ui/TweetEmbed'
export default TweetEmbed
